export const COMPANY_SUBSCRIPTION_ROUTES = {
  subscriptionPortalSession: '/company/:cid/subscriptionPortalSession',
  editAutoRenew: '/company/:cid/editAutoRenew',
  createSubscription: '/company/:cid/createSubscription',
  upgradeSubscription: '/company/:cid/upgradeSubscription',
  cancelSubscription: '/company/:cid/cancelSubscription',
  retrySubscriptionPayment: '/company/:cid/retrySubscriptionPayment',
  subscriptionPaymentIntent: '/company/:cid/subscriptionPaymentIntent/:stripeSubscriptionId',
};
